import React from 'react';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';

import t from 'react-translate';
import NvSwitch from 'shared/components/inputs/nv-switch';
import { halfSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import { getCourseAliases } from 'redux/selectors/course';
import { gray6, lightSoftYellow } from 'styles/global_defaults/colors';
import { config } from '@config/pendo.config.json';

type Props = {
  initialValue: boolean,
  onChange: (newChecked: boolean) => void,
  isJourney?: boolean,
  disabled?: boolean,
};

const AutomatedTranslationSwitch = (props: Props) => {
  const { onChange, initialValue, isJourney = false, disabled = false } = props;
  const aliases = useSelector((state) => getCourseAliases(state));

  const mountedRef = React.useRef(false);
  const [value, setValue] = React.useState(!disabled && initialValue);
  const onChangeRef = React.useRef<(checked: boolean) => void>();
  onChangeRef.current = onChange;

  React.useEffect(() => {
    if (mountedRef.current) {
      onChangeRef.current(value);
    } else {
      mountedRef.current = true;
    }
  }, [value]);

  const styles = css`
    & > * {
      vertical-align: middle;
    }

    .nv-switch {
      margin-right: ${halfSpacing}px;
      &.disabled .switch-container {
        background-color: ${gray6};
      }
    }
    .original-content-language-note {
      background-color: ${lightSoftYellow};
      margin-top: ${standardSpacing}px;
      padding: ${standardSpacing}px;
    }
  `;

  return (
    <React.Fragment>
      <div css={styles}>
        <NvSwitch
          enabledIcon='gen-ai'
          checked={value}
          onChange={setValue}
          className={`nv-switch ${disabled ? 'disabled' : ''}`}
          disabled={disabled}
          data-qa={
            isJourney
              ? config.pendo.automatedTranslation.journeyAutomatedTranslationSwitch
              : config.pendo.automatedTranslation.courseAutomatedTranslationSwitch
          }
        />
        <span className='text-body'>
          {
            isJourney
              ? t.LEARNING_JOURNEYS.DASHBOARD.LANGUAGE_MODAL.AUTOMATED_TRANSLATION_SWITCH_LABEL()
              : t.COURSE_HOME.LANGUAGE.AUTOMATED_TRANSLATION_SWITCH_LABEL(aliases.courseAliases)
          }
        </span>
        {
          value && (
            <div className='original-content-language-note text-body'>
              {t.COURSE_HOME.LANGUAGE.ORIGINAL_CONTENT_LANGUAGE_NOTE()}
            </div>
          )
        }
      </div>
    </React.Fragment>
  );
};

export default AutomatedTranslationSwitch;
